import { formatToCurrency, formatToDecimal } from 'utils/formatUnits'
import { useContext } from 'react'
import { ViewerContext } from 'context/ViewerContext'
import { viewer } from 'utils/launchViewer'
import ArticuloTableRowPrice from 'components/Modulo/ArticuloTableRowPrice'

const ArticulosRow = ({ articulo }) => {
  const totalPrice = Number(articulo.precio || 0) * articulo.quantity
  const { externalIdsMapping } = useContext(ViewerContext)

  const isolateDbIds = () => {
    const dbIds = articulo.externalIds.map(item => externalIdsMapping[item])
    viewer.isolate(dbIds)
  }
  return (
    <tr
      className="table-row-bigger custom-table-row-body"
      onClick={isolateDbIds}
    >
      <td>{articulo?.articulo?.code}</td>
      <td>{articulo?.articulo?.name}</td>
      <ArticuloTableRowPrice
        articulo={{ ...articulo, precioArticuloProyecto: articulo._id }}
        showUnit={false}
        removeQueries={false}
      />
      <td className="ta-right">
        {formatToDecimal(articulo?.quantity)}
        {articulo?.articulo?.unit}
      </td>
      <td className="ta-right">{formatToCurrency(totalPrice)}</td>
    </tr>
  )
}

export default ArticulosRow
